export const contractTypes = {
    1: "employment",
    2: "b2b",
    3: "specificWork",
    4: "mandate",
    5: "substitute",
    6: "agency",
    7: "temporary",
    8: "internship",
} as const;

export const salaryTypes = {
    1: "gross",
    2: "net",
} as const;

export const currencyTypes = {
    1: "PLN",
    2: "EUR",
    3: "USD",
    4: "UAH",
} as const;

export type ContractTypeKey = keyof typeof contractTypes;
export type SalaryTypeKey = keyof typeof salaryTypes;
export type CurrencyTypeKey = keyof typeof currencyTypes;

export type ContractTypeValue = (typeof contractTypes)[ContractTypeKey];
export type SalaryTypeValue = (typeof salaryTypes)[SalaryTypeKey];
export type CurrencyTypeValue = (typeof currencyTypes)[CurrencyTypeKey];

export interface SalaryRange {
    minAmount: number | null;
    maxAmount: number | null;
    currencyId: CurrencyTypeKey | null;
    salaryTypeId: SalaryTypeKey | null;
    contractTypeId: ContractTypeKey | null;
}

export interface CompensationPackage {
    salaryRanges?: SalaryRange[];
    benefits?: string;
    showCompensationPackage: boolean;
}
